<template>
  <md-button
    class="md-just-icon md-warning md-simple table-action"
    @click.native="triggerDetail"
  >
    <md-icon>visibility</md-icon>
  </md-button>
</template>
<script>
export default {
  props: ["item"],
  inject: ["viewSubmittedReport"],
  methods: {
    triggerDetail() {
      this.viewSubmittedReport(this.item);
    }
  }
};
</script>
